module.exports = __webpack_public_path__ + "static/media/my-video.07f317be.mp4";